
const initialState = {
  data: {
    resultContainer: [],
  },
  error: null,
  loading: false,
  payload: {
    sortingCriteria: "DATE_NEWEST_TO_OLDEST"
  }
};

export const listQueryPageRequest = (namespace) => (state = initialState, action) => {
  switch (action.type) {
    case `${namespace}/LIST_QUERY_PAGE_REQUEST_REQUEST`: {
      return { ...state, data: initialState.data, error: null, loading: true };
    }
    case `${namespace}/LIST_QUERY_PAGE_REQUEST_SUCCESS`: {
      return { ...state, data: { resultContainer: action?.data?.resultContainer }, loading: false };
    }
    case `${namespace}/LIST_QUERY_PAGE_REQUEST_FAILURE`: {
      return { ...state, data: { resultContainer: [] }, error: action?.error, loading: false };
    }
    case `${namespace}/LIST_QUERY_PAGE_REQUEST_SET_PAYLOAD`: {
      return { ...state, data: { ...state.data, page: 0, pageSize: state.data.pageSize }, payload: action.data };
    }
    case `${namespace}/LIST_QUERY_PAGE_REQUEST_RESET_PAYLOAD`: {
      return { ...state, data: { ...state.data, page: 0, pageSize: state.data.pageSize }, payload: { ...initialState.payload } };
    }
    case `${namespace}/LIST_QUERY_PAGE_REQUEST_RESET`: {
      return initialState;
    }
    default:
      return state;
  }
};
